import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default ({
  data,
  getText,
  setRetrieveValues,
}: {
  data: IMultiElementCombineMsg.ITextareaElem;
  getText: (text: IMultiElementCombineMsg.IText) => string;
  setRetrieveValues: (value: IMultiElementCombineMsg.IRetrieveValues) => void;
}) => {
  const {
    id,
    type,
    title,
    isRequire,
    value,
    disable,
    maxLength,
    placeholder_title,
  } = data;

  const [textValue, setTextValue] = useState(value);

  const style = getDefaultComponentStyle(data);

  useEffect(() => {
    setTextValue(value);
  }, [value]);

  const titleStr = getText(title);

  const changeHandle = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.trim();
    setTextValue(value);
    setRetrieveValues({ id, type, value });
  };
  return (
    <div className={"sscard-textareaBox"} style={style}>
      {titleStr ? (
        <div className={`${"textareaTitle"} ${isRequire ? "isRequire" : ""}`}>
          {titleStr}
        </div>
      ) : null}
      <div className={"textareaContent"} onClick={(e) => e?.stopPropagation()}>
        <Input.TextArea
          placeholder={getText(placeholder_title)}
          value={textValue}
          allowClear={false}
          disabled={Boolean(disable)}
          maxLength={maxLength}
          autoSize={{ minRows: 6, maxRows: 6 }}
          onChange={changeHandle}
        />
      </div>
    </div>
  );
};
